import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Scanner from './pages/Scanner';
import Expenses from './pages/Expenses';
import Export from './pages/Export';
import BOLSend from './pages/BOLSend';
import Settings from './pages/Settings';
import ImportSettlement from './pages/ImportSettlement';
import ImportComdata from './pages/ImportComdata';
import ImportTravel from './pages/ImportTravel';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute><Layout><Upload /></Layout></ProtectedRoute>} />
      <Route path="/scanner" element={<ProtectedRoute><Layout><Scanner /></Layout></ProtectedRoute>} />
      <Route path="/bol-send" element={<ProtectedRoute><Layout><BOLSend /></Layout></ProtectedRoute>} />
      <Route path="/expenses" element={<ProtectedRoute><Layout><Expenses /></Layout></ProtectedRoute>} />
      <Route path="/export" element={<ProtectedRoute><Layout><Export /></Layout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><Layout><ImportSettlement /></Layout></ProtectedRoute>} />
      <Route path="/import-fuel" element={<ProtectedRoute><Layout><ImportComdata /></Layout></ProtectedRoute>} />
      <Route path="/import-travel" element={<ProtectedRoute><Layout><ImportTravel /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;






